import { all, call, put, takeLatest } from "redux-saga/effects"

import { generateTree } from "utils/utils"

import { GET_DIMENSIONS_WATCHER } from "./constants"

import { getDimensionsSuccess, getDimensionsFailed } from "./actions"
import {
  getDimensionsApi,
  getTeamsApi,
  getQuestionsApi,
} from "../../../../../utils/routes/routes-report"

export function* getDimensionsSaga(action) {
  try {
    const dataStatus = action.payload
    const [
      { data: dimensionsApi, metric_total: metricTotal },
      { data: questionsApi },
      { data: teamsApi },
    ] = yield all([
      call(getDimensionsApi, dataStatus),
      call(getQuestionsApi, dataStatus),
      call(getTeamsApi, dataStatus),
    ])
    let questions = questionsApi
    if (questions.error != "No data") {
      questions.map((e) => {
        e.id = parseInt(
          e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
        )
      })
    } else {
      questions = []
    }
    let dimensions = dimensionsApi
    if (dimensions.error === "No data") {
      dimensions = []
    }
    const result = {}
    result.metric_total = metricTotal
    result.teams = teamsApi
    result.dimensions_drill_down = generateTree("id", "id_parent", [
      ...JSON.parse(JSON.stringify(dimensions)),
      ...JSON.parse(JSON.stringify(questions)),
    ])
    yield put(getDimensionsSuccess(result))
  } catch (e) {
    yield put(getDimensionsFailed())
  }
}

// Individual exports for testing
export default function* widgetResultByDimensionTeamSaga() {
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
}
